import { render, staticRenderFns } from "./mobile_markets_list.vue?vue&type=template&id=edbedc46&"
import script from "./mobile_markets_list.vue?vue&type=script&lang=js&"
export * from "./mobile_markets_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports